
import React, { useEffect, useState }  from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { compose, toClass } from 'recompose';
import { Form, Input, Segment, Label, Breadcrumb, Header } from 'semantic-ui-react';
import axios from "axios";
import { withLocale } from 'op/components/locale';
import { withReportMetadata } from './report-meta.helper';

const ClassedFormInput = toClass(Form.Input);
const DatePickerWrapper = styled.div`
	.react-datepicker-wrapper, 
	.react-datepicker__input-container {
		width: 100%;	
	}
`;

const ReportMeta = ({ locale, person, readOnly, ready, report, types, categories, setType, invokeChange }) => {
	const [fieldValue, setFieldValue] = useState();
	const [isMultipleValue, setIsMultipleValue] = useState();
	useEffect(() => {
		setFieldValue(103);
		setIsMultipleValue(true)
        axios.get('/api/common/terms').then(response => {
            setFieldValue(response.data.dateConvertCode);
			setIsMultipleValue(response.data.isMultiple)
        }).catch(ex => console.log(ex.message));
    }, []);
	return(
	<Segment loading={!ready}>
		<Header>
	    <Breadcrumb>
	      <Breadcrumb.Section link as={Link} to="/">{locale.search}</Breadcrumb.Section>
	      <Breadcrumb.Divider />
			{!isNaN(report.id)
				? <Breadcrumb.Section link as={Link} to={`/person/${report.person_id}`}>{ person ? person.name : report.person_id }</Breadcrumb.Section>
				: <Breadcrumb.Section link as={Link} to={`#`}>Group Task</Breadcrumb.Section>}
	      <Breadcrumb.Divider />
	      <Breadcrumb.Section active>{ !!report.id ? report.id : locale.breadcrumb }</Breadcrumb.Section>
	    </Breadcrumb>
    </Header>
		<Form.Group widths='equal'>
			<Form.Field required={!readOnly.includes('timestamp')}>
				<label>{ locale.timestamp }</label>
				{	readOnly.includes('timestamp') ? (
					<Input readOnly value={ report.timestamp && moment(report.timestamp).locale('en').format(fieldValue==103?'DD/MM/YYYY HH:mm':'MM/DD/YYYY HH:mm') } />
				) : (
					fieldValue==103?(
					<DatePickerWrapper>
						<DatePicker
							customInput={ <ClassedFormInput fluid type="text" /> }
							placeholderText={ locale.timestamp }
							selected={ report.timestamp && new Date(report.timestamp) }
							onChange={ (date) => invokeChange({ timestamp: { $set: date } }) }
							showTimeSelect
							dateFormat="dd/MM/yyyy HH:mm"
						/>
					</DatePickerWrapper>):
					(
						<DatePickerWrapper>
							<DatePicker
								customInput={ <ClassedFormInput fluid type="text" /> }
								placeholderText={ locale.timestamp }
								selected={ report.timestamp && new Date(report.timestamp) }
								onChange={ (date) => invokeChange({ timestamp: { $set: date } }) }
								showTimeSelect
								dateFormat="MM/dd/yyyy HH:mm"
							/>
						</DatePickerWrapper>)

				)}
			</Form.Field>
			<Form.Input
				fluid
				label={ locale.location } 
				placeholder={ locale.location }
				value={ report.location || '' }
				readOnly={ readOnly.includes('location') } 
				onChange={ (e) => invokeChange({ location: { $set: e.target.value } }) } 
			/>
		</Form.Group>
		<Form.Group widths='equal'>
			{	readOnly.includes('type') ? (
				<Form.Field>
					<label>{ locale.type }</label>
					<Input readOnly value={ report.type && report.type.name } />
				</Form.Field>
			) : (
				<Form.Dropdown
					required
					fluid 
					label={ locale.type }
					placeholder={ locale.type }
					
					selection
					scrolling
					value={ report.type && report.type.id } 
					options={ types
						.filter(x=>!x.isexpired)
						.map(({ id, name }) => ({ key: id, text: name, value: id })) }
					onChange={ (_, { value }) => setType(types.find(({ id }) => id === value)) } 
				/>
			)}
			{	readOnly.includes('category') ? (
					<Form.Field>
						<label>{ locale.category }</label>
						<Form.Dropdown
							required
							fluid
							multiple
							selection
							scrolling
							value={ Array.isArray(report.category) ? report.category.map(catId => catId) : [] }
							options={
								((report.type && categories[report.type.id]) || [])
								//.filter(x=>!x.isexpired)
									.map(({ id, name }) => ({ key: id, text: name, value: id }))
							}
							loading={
								(report.type
									&& categories[report.type.id]
									&& categories[report.type.id].length == 0)
							}

						/>
					</Form.Field>
			) : isMultipleValue?(
				<Form.Dropdown
					required
					fluid
					label={ locale.category }
					placeholder={ locale.category }
					multiple
					selection
					scrolling
					value={ Array.isArray(report.category) ? report.category.map(catId => catId) : [] }
					options={ 
						((report.type && categories[report.type.id]) || [])
						.filter(x=>!x.isexpired)
							.map(({ id, name }) => ({ key: id, text: name, value: id })) 
					}
					loading={
						(report.type 
							&& categories[report.type.id] 
							&& categories[report.type.id].length == 0)
					}
					onChange={ (_, { value }) => invokeChange({ category: { $set: categories[report.type.id].filter(({ id }) => value.includes(id)).map(({ id }) => id) } }) }
				/>
			):
			(
				<Form.Dropdown
					required
					fluid
					label={ locale.category }
					placeholder={ locale.category }
					
					selection
					scrolling
					options={ 
						((report.type && categories[report.type.id]) || [])
						.filter(x=>!x.isexpired)
							.map(({ id, name }) => ({ key: id, text: name, value: id })) 
					}
					loading={
						(report.type 
							&& categories[report.type.id] 
							&& categories[report.type.id].length == 0)
					}
					onChange={ (_, { value }) => invokeChange({ category: { $set: categories[report.type.id].filter(({ id }) => value==id).map(({ id }) => id) } }) }
				/>
			)}
		</Form.Group>
	</Segment>
)};

export default compose(
	withLocale('report.meta'),
	withReportMetadata,
	hot(module),
)(ReportMeta);